import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { History } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import drawer from './modules/drawer';
import comparison from './modules/comparison';
import comparisonHighlight from './modules/comparisonHighlight';
import comparisonHighlightSave from './modules/comparisonHighlightSave';
import comparisonSearch from './modules/comparisonSearch';
import comparisonTsv from './modules/comparisonTsv';
import upload from './modules/upload';
import uploadForHighlight from './modules/uploadForHighlight';
import uploadForSearch from './modules/uploadForSearch';
import uploadForRiskJudge from './modules/uploadForRiskJudge';
import apply from './modules/apply';
import search from './modules/search';
import searchTsv from './modules/searchTsv';
import tags from './modules/tags';
import update from './modules/update';
import riskJudge from './modules/riskJudge';
import deleteMod from './modules/delete';

export default function configureStore(history: History) {
  const reducer = combineReducers({
    drawer,
    comparison,
    comparisonHighlight,
    comparisonHighlightSave,
    comparisonSearch,
    comparisonTsv,
    upload,
    uploadForHighlight,
    uploadForSearch,
    uploadForRiskJudge,
    apply,
    search,
    searchTsv,
    tags,
    update,
    riskJudge,
    deleteMod,
  });

  const middleware = [
    routerMiddleware(history),
    thunk,
  ];

  return createStore(
    connectRouter(history)(reducer),
    composeWithDevTools(
      applyMiddleware(...middleware),
    ),
  );
}



// WEBPACK FOOTER //
// ./src/configureStore.ts